import { dateFromIso } from "../utils/index";

interface IResult {
  date: string;
  time: string;
}

/**
 * Compare available date or time to date group in store
 * e.g. {"2019-04-11T23:00:00.000Z": ["2019-04-12T06:00:00+0100"]}
 * @param date date string
 * @param time time string
 */
export function availableDateTime(date: string, time?: string): IResult {
  // date group
  const availableDate = dateFromIso(date)
    .startOf("day")
    .setZone("utc")
    .toFormat("yyyy-LL-dd'T'HH:mm:ss'.000Z'");

  const availableTime = dateFromIso(time || date).toFormat(
    "yyyy-LL-dd'T'HH:mm:ssZZZ",
  );

  return { date: availableDate, time: availableTime };
}
